import React from 'react';
import { t } from 'i18next';

import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { requestLiveActivityLeaderboard, requestPlayerContentExport } from 'Store/entities/analytics/analytics.api';
import { enqueueBasicAlert } from 'Pages/AlertManager';
import { ExportCard } from './ExportCard/ExportCard';

import styles from './Exports.style';

const ALERT_DURATION = 5000;
export const Exports = () => {
  const handleLeaderboardDownload = async (startDate: Date, endDate: Date) => {
    try {
      await requestLiveActivityLeaderboard(startDate, endDate);
      enqueueBasicAlert(
        {
          id: 'leaderboard_report_download_success',
          status: 'success',
          text: t('analytics:reports.success_downloading'),
        },
        ALERT_DURATION,
      );
    } catch (e) {
      enqueueBasicAlert(
        {
          id: 'leaderboard_report_download_error',
          text: t('analytics:reports.error_downloading'),
          status: 'error',
        },
        ALERT_DURATION,
      );
    }
  };

  const handlePlayerContentDownload = async (startDate: Date, endDate: Date) => {
    try {
      await requestPlayerContentExport(startDate, endDate);
      enqueueBasicAlert(
        {
          id: 'player_content_report_download_success',
          status: 'success',
          text: t('analytics:reports.success_downloading'),
        },
        ALERT_DURATION,
      );
    } catch (e) {
      enqueueBasicAlert(
        {
          id: 'player_content_report_download_error',
          text: t('analytics:reports.error_downloading'),
          status: 'error',
        },
        ALERT_DURATION,
      );
    }
  };

  return (
    <div style={styles.pageContainer}>
      <div style={styles.pageWrapper}>
        <div style={styles.titleWrapper}>
          <h1 style={{ ...TYPOGRAPHY.HERO_L_SEMIBOLD }}>{t('analytics:reports.reports_title')}</h1>
          <p style={{ ...TYPOGRAPHY.BODY3, color: COLORS.TEXT.SECONDARY_DEFAULT }}>
            {t('analytics:reports.active_campaign_leaderboards_subtitle')}
          </p>
        </div>
        <div style={styles.cardsWrapper}>
          <ExportCard
            title={t('analytics:reports.active_campaign_leaderboards')}
            subtitle={t('analytics:reports.active_campaign_leaderboards_subtitle')}
            onDownload={handleLeaderboardDownload}
          />
          <ExportCard
            title={t('analytics:reports.content_analytics_per_player')}
            subtitle={t('analytics:reports.content_analytics_per_player_subtitle')}
            onDownload={handlePlayerContentDownload}
          />
        </div>
      </div>
    </div>
  );
};
